import { defineStore, acceptHMRUpdate } from 'pinia'

export interface EditServiceData {
  // Pre-filled values when opening the business service form for editing.

  serviceTypeId: string
  // Selected service type id (UUID7).

  dateTime: string
  // ISO 8601 datetime of the service occurrence.

  performerIds: string[]
  // Person ids of the assigned performers.

  clientIds: string[]
  // Person ids of the attending clients.

  groupId: string | null
  // Id of the client group the service belongs to; null for an ad-hoc service.

  description: string | null
  // Optional free-text description; null when absent.

  price: number
  // Service price in major currency units.
}

export const useAddBusinessServiceFormStore = defineStore('addBusinessServiceForm', {
  state: () => ({
    isOpen: false,
    editId: null as string | null,
    editData: null as EditServiceData | null,
  }),
  actions: {
    open(): void {
      this.isOpen = true
      this.editId = null
      this.editData = null
    },
    openForEdit(id: string, data: EditServiceData): void {
      this.isOpen = true
      this.editId = id
      this.editData = data
    },
    close(): void {
      this.isOpen = false
      this.editId = null
      this.editData = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddBusinessServiceFormStore, import.meta.hot))
}
